<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="user-plus"
    title="Тариф"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
    [minimized]="true"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div *ngIf="(senderService.account$ | async) as account" class="modal-container">
        <div class="modal-block">
          <div class="modal-content p-4">


            <div class="big-text">
              <ng-template [ngIf]="account.tariff === 'test'">
                {{ account.tariff_paid | timeago }} {{(senderService.expiredTariff$ | async) ? 'закончился' : 'закончится'}}
                пробный период :(
              </ng-template>
              <ng-template [ngIf]="account.tariff === 'full' || account.tariff === 'start'">
                {{ account.tariff_paid | timeago }} {{(senderService.expiredTariff$ | async) ? 'закончился' : 'закончится'}}
                месячный абонимент :(
              </ng-template>
            </div>
            <div class="row">
              <div class="col">
                <nz-radio-group (ngModelChange)="calcTariffPrice()" [(ngModel)]="period" class="mb-3">
                  <label nz-radio-button [nzValue]="1">1 мес.</label>
                  <label nz-radio-button [nzValue]="3">3 мес.</label>
                  <label nz-radio-button [nzValue]="6">6 мес.</label>
                  <label nz-radio-button [nzValue]="12">год</label>
                </nz-radio-group>
                <div class="d-flex align-items-center mb-4">
                  <div class="tarifs mr-2">
                    <div class="value old"><small>{{senderService.tariffPrice}}</small></div>
                    <div class="value active">
                      <span>{{price$ | async}} ₽/<small>мес.</small></span>
                    </div>
                  </div>

                  <div *ngIf="account.tariff === 'test' && period === 1">
                    <div class="text-underline pointer" (click)="showPromoCode$.next(true)"
                          *ngIf="!(showPromoCode$ | async)">
                      Промокод
                    </div>
                    <nz-form-control *ngIf="(showPromoCode$ | async)" [nzValidateStatus]="promoCodeStatus()"
                                     nzWarningTip=""
                                     nzErrorTip=""
                                     nzHasFeedback>
                      <input class="promo-code-input" nz-input placeholder="Введите код" (ngModelChange)="calcTariffPrice()" [(ngModel)]="promoCode"/>
                    </nz-form-control>
                  </div>
                </div>



                <div class="tarifs-contents">
                  <div class="tarif-content active">
                    <div class="small-text">В стоимость полного тарифа входит:</div>
                    <div class="points">
                      <div class="point">
                        <div class="point-icon">
                          <i-feather name="scan" class=""></i-feather>
                        </div>
                        <div class="point-text">Направлений для сканирования без ограничений</div>
                      </div>
                      <div class="point">
                        <div class="point-icon">
                          <i-feather name="chats" class=""></i-feather>
                        </div>
                        <div class="point-text">Телеграм чаты для анализа без ограничений</div>
                      </div>
                      <div class="point">
                        <div class="point-icon">
                          <i-feather name="user2" class=""></i-feather>
                        </div>
                        <div class="point-text">Телеграм аккаунт для работы</div>
                      </div>
                      <div class="point">
                        <div class="point-icon">
                          <i-feather name="history" class="normal"></i-feather>
                        </div>
                        <div class="point-text">Сканирование истории чатов за 5 дней</div>
                      </div>
                      <div class="point">
                        <div class="point-icon">
                          <i-feather name="tasks" class=""></i-feather>
                        </div>
                        <div class="point-text">Создание заданий по готовым шаблонам</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="price mr-3">{{(price$ | async) * period}} ₽</div>
                      <button (click)="paidTariff()" nz-button nzType="primary" nzSize="large" nzShape="round">
                        Оплатить
                        <i-feather name="credit-card" class="ml-2"></i-feather>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-5 d-none d-lg-block">
                <img src="/assets/images/mbg-svg.svg" alt="">
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>
